import {getInfo} from "@/api/user";

const state = {
  user: {}, // 存储个人数据
  permissionCodes: [], // 新增字段，用于存储 permissionCodes
  roles: [],  // 用户角色列表
};

const mutations = {
  SET_USER: (state, userData) => {
    state.user = userData;
  },
  RESET_USER: (state) => {
    state.user = {};
    state.permissionCodes = []; // 重置 permissionCodes
  },
  SET_PERMISSION_CODES: (state, permissionCodes) => {
    state.permissionCodes = permissionCodes; // 设置 permissionCodes
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
};

const getters = {
  user: (state) => state.user,
  permissionCodes: (state) => state.permissionCodes, // 新增 getter
  roles: (state) => state.roles,
};

const actions = {
  // 新增 action 用于调用 getInfo 接口
  fetchUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then((res) => {
          // 直接解构提取 userInfo 和 permissionCodes
          const { userInfo, permissionCodes, roles } = res.data;
          if (userInfo) {
            // 存储用户信息
            commit("SET_USER", userInfo);
          }

          if (permissionCodes) {
            // 存储 permissionCodes
            commit("SET_PERMISSION_CODES", permissionCodes);
          }

          if (roles) {
            // 存储 roles
            commit("SET_ROLES", roles);
          }

          resolve(res);
        })
        .catch((error) => {
          console.error("Error fetching user info:", error);
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
